import Vue from 'vue';
import Vuex from 'vuex';

import authModule from './modules/auth';
import alertsModule from './modules/alerts';
import clientsModule from './modules/clients';
import usersModule from './modules/users';
import failuresModule from './modules/failures';
import notesModule from './modules/notes';
import documentsModule from './modules/documents';
import expensesModule from './modules/expenses';
import tasksModule from './modules/tasks';
import productsModule from './modules/products';
import stocksModule from './modules/stocks';
import analyzersModule from './modules/analyzers';
import settingsModule from './modules/settings';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  modules: {
    users: usersModule,
    auth: authModule,
    alerts: alertsModule,
    clients: clientsModule,
    failures: failuresModule,
    notes: notesModule,
    documents: documentsModule,
    expenses: expensesModule,
    tasks: tasksModule,
    products: productsModule,
    stocks: stocksModule,
    analyzers: analyzersModule,
    settings: settingsModule,
  },
  getters: {
  },
});
